import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";
import anim_line from "../../img/winter.png"
import { useParams ,useHistory, useRouteMatch,} from "react-router-dom";

import LoadingButton from "../../Loading/LoadingButton";
import { useSelector } from "react-redux";
import {Activity, HopIcon, Plus } from 'lucide-react';
import Snackbar from "../../../Snackbar";
import { createCourseByAdminV2 } from "../../../store/actions/CreateCourse/createCourseByAdmin";
import AppMenuCardBlue from "../AppCards/AppMenuCardBlue";
import { getProductByProductId } from "../../../api";
import AreYouSurePopUp from "../../Create/CreateContent/ContentPopUp/AreYouSurePopUp";
import WhatsIncludedAddMore from "../../Create/CreateCourse/WhatsIncludedAddMore";
import AppMenuCardBlueBG from "../AppCards/AppMenuCardBlueBG";
import NextStepCardPopUp from "../AppCards/NextStepCardPopUp";
const ApproxContents = ({setActiveCardOverview,baseUrl})=>{
  const {courseId} = useParams();
  const {url}=useRouteMatch();
  const history = useHistory();
   const dispatch = useDispatch();

   const [snackbarVisible, setSnackbarVisible] = useState(false);
   const [snackbarColor, setSnackbarColor] = useState("#958FDA");
   const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
 
  const [goNextPopUp, setGoNextPopUp] =useState(false);
 
 const showSnackbar = () => {
   setSnackbarVisible(true);
 };

 const hideSnackbar = () => {
   setSnackbarVisible(false);
 };
 const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
  {
    
    dispatch({type: "CURSOR",payload:true  });

    dispatch({type: "CURSORTEXT",payload:CursorText})
    dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
    dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
  }
   
  const handleMouseLeave = () => {
    
    dispatch({type: "CURSOR",payload:false})

    dispatch({type: "CURSORTEXT",payload:""})

    dispatch({type: "CURSORTEXTBG",payload:""})
    dispatch({type: "CURSORTEXTCOLOR",payload:""})
  

}
  
 const token = useSelector((state)=>state?.course?.course?.token);
 const currentToken = useSelector((state)=>state?.user?.user?.token);
 const user_email = useSelector((state)=>state?.user?.user?.user_email
);

const postIdCourse = useSelector((state)=>state?.course?.course?.postId);

const courseData = useSelector((state)=>state?.course?.course);
const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
const appId = useSelector((state)=>state?.app?.app?.ID);
const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);

 const [loader , setLoader] =useState({status:false});
 const [productID, setProductID] = useState(courseData?.ID?courseData?.ID:"");
 const [editType, setEditType] = useState(courseData?.ID?"materialIncluded":"");
const materialIncluded =courseData?.materialIncluded?JSON.parse(courseData?.materialIncluded):[];
 const [itemArr, setItemArr] = useState(materialIncluded?.length?materialIncluded:[]);
 
 const [animate, setAnimate] = useState(false);

 useEffect(() => {
    // console.log(itemArr)
   // Trigger the animation after a delay (e.g., 500ms)
   const timer = setTimeout(() => {
    setAnimate(true);  
  }, 100);

   return () => clearTimeout(timer); // Cleanup on unmount
 }, []);
useEffect(()=>{
  setActiveCardOverview(true);
  
  // setCourseTitleData();
},[])



  const handleCreateProduct=()=>{
  
  
  
  setLoader({status:true});
  
    const apiData = dispatch(createCourseByAdminV2({materialIncluded:JSON.stringify(itemArr),type:courseData?.ID?courseData?.type:"course",
      postParent:"0" ,userEmail:user_email?user_email:"",
      currentToken:currentToken?currentToken:"",
      editType:editType,postId:productID,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}));
    /* get response as Promise   */
    apiData.then(response => {
      if(response){
        if(response?.course){
          
      setResponseMessage(response?.message);
      setSnackbarColor("rgba(144, 202, 249,1)");
    
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
    setItemArr(JSON.parse(response?.course?.materialIncluded));
    setProductID(response?.course?.postId);
   setEditType("materialIncluded")
   setGoNextPopUp(true);
  },1000)
     }else{
      setResponseMessage("Something Went Wrong...");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
     }
        
     
     if(response?.logout){
     
      setResponseMessage("You are Logged Out!!!");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      setTimeout(()=>{
        dispatch({type:"LOGOUT"});
  
      },3000)
      
    }
  /* resetting Login input Fields */
  
      }else{
        setResponseMessage("Something Went Wrong...");
        
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)    }
  
    }).catch(error => {
   
      //popup of error Info
      setResponseMessage("Something Went Wrong...");
        
      setSnackbarColor("#958FDA");
   
       
  setLoader({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      console.error(error);
    });
   
    }
    
    function generateTimestamp() {
        return Math.floor(Date.now() / 1000);
      }
     
     useEffect(() => {
       // Trigger the animation after a delay (e.g., 500ms)
       const timer = setTimeout(() => {
        setAnimate(true);  
      }, 100);
    
       return () => clearTimeout(timer); // Cleanup on unmount
     }, []);
    
     const removeItem = (id) => {
        const filteredItems = itemArr.filter(item => item.id !== id);
        setItemArr(filteredItems);
      };
      const updateItemTotalNumber = (id, newTotalNumber) => {
        const updatedItems = itemArr.map(item =>
          item.id === id ? { ...item, totalNumber: newTotalNumber } : item
        
        ); 
        setItemArr(updatedItems);
      };const updateItemTitle = (id, newTitle) => {
        const updatedItems = itemArr.map(item =>
          item.id === id ? { ...item, contentType :newTitle } : item
        
        ); 
        // console.log(updatedItems)
        setItemArr(updatedItems);
      };
      const updateItemStatus = (id, status) => {
        const updatedItems = itemArr.map(item =>
          item.id === id ? { ...item, status: status } : item
        
        );
    
    
    
        setItemArr(updatedItems);
    
        
        setTimeout(()=>{
          // console.log(updatedItems)
              },1000)
      };
    const flattenedData = itemArr.length?Object.values(itemArr):[];
    
    
    
const handleBack=(e)=>{
  
    setLoader({status:true});
    
    history.goBack();
    }
    
    
    
    useEffect(()=>{
      // setCourseTitleData();
    // console.log(itemArr)
    materialIncluded.length?setItemArr(materialIncluded):
      setItemArr([{ no:1, id: generateTimestamp(), totalNumber: 0,status:false,contentIcon:`Video`
        ,contentType:"Video Lectures" ,editable:false},
        {no:2, id: generateTimestamp()+1, totalNumber: 0,status:false,contentIcon:`MonitorPlay`,
        contentType:"Live Classes",editable:false },
        {no:3, id: generateTimestamp()+2, totalNumber: 0,status:false,contentIcon:`NotepadText`,
        contentType:"Topic Quizzes",editable:false },
        {no:4, id: generateTimestamp()+3, totalNumber: 0,status:false,contentIcon:`TabletSmartphone`,
        contentType:"Mock Tests" ,editable:false},
        // {no:5, id: generateTimestamp()+4, totalNumber: 0,status:false,contentIcon:`BookDown`,
        // contentType:"PDF Notes",editable:false },
        // {no:6, id: generateTimestamp()+5, totalNumber: 0,status:false,contentIcon:`GalleryHorizontal`,
        // contentType:"Flash Cards",editable:false },
       {no:7, id: generateTimestamp()+6, totalNumber: 0,status:false,contentIcon:`BookA`,
        contentType:"Assignments & Homework",editable:false },
        {no:8, id: generateTimestamp()+7, totalNumber: 0,status:false,contentIcon:`BookOpenCheck`,
        contentType:"Physical Notes & Books" ,editable:false},
        
    
    ]);
    },[])
    
    
    return <>
    
{<>
  {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor} onClose={hideSnackbar} />
      )}

<div  className="ikcraft_login-signup-card-outerj"style={{}}><div  className="CreateCourseStepsOuter contentPageScroller" style={{background:"#fff",borderRadius:"25px"}}>
<div > 
<div  className=""style={{
        transform: animate ? 'scale(1)' : 'scale(.9)',marginTop:"20px",
        opacity: animate ? 1 : 0,
        transition: 'transform 2s ease, opacity 1s ease',
      }}>
         
<div align="left" className="itemCourseOuter" style={{marginTop:"0px",marginBottom:"0px",height:"230px",background:"rgba(86, 82, 131,.8)"}}> 
                
                <div  className="whatToDoNextItemCardInner" ><div style={{background:"#fff",width:"50px",height:"50px",borderRadius:"50%",
                      float:"left",alignContent:"center",textAlign:"center",padding:"5px"}}><HopIcon size={32}  color="rgb(86, 82, 131)"/></div> 
              
                
                </div><div style={{display:"flex",justifyContent:"center"}}>
                <h2 style={{color:"#fff"}}>Add Actual Contents</h2> 
                  </div> 
              <div  style={{display:"flex",justifyContent:"center"}}>
              <AppMenuCardBlue activeCard={""} icon={1} title ="Add Contents " onClickPopup={
          ()=>{  history.push(`${baseUrl}/content`)
          }}  />
           </div>   </div>
           
           <div  className="ikcraft_login-input-card"style={{
       
       transition: 'transform 2s ease, opacity 1s ease',
     }}>
 <h3>Next Steps</h3> 
     <div className="" style={{"textAlign":"center",
                    transform: animate ? 'translateY(0)' : 'translateY(50px)',
                    opacity: animate ? 1 : 0,
                   transition: `transform ${1+2}s ease, opacity ${1+2}s ease`
                  ,display:"flex",justifyContent:"center"}}>
  
         <AppMenuCardBlueBG  activeCard={""} icon={5} title ="Add Thumbnail " onClickPopup={
           ()=>{ history.push(`${baseUrl}/thumbnails`)
           }}  />
  </div> <div className="" style={{"textAlign":"center",
                    transform: animate ? 'translateY(0)' : 'translateY(50px)',
                    opacity: animate ? 1 : 0,
                   transition: `transform ${1+3}s ease, opacity ${1+3}s ease`
                  ,display:"flex",justifyContent:"center"}}>
  <AppMenuCardBlueBG activeCard={""} icon={4} title ="Add Demo Videos " onClickPopup={
             ()=>{  history.push(`${baseUrl}/demo-videos`)
             }}  /> </div><div className="" style={{"textAlign":"center",
                transform: animate ? 'translateY(0)' : 'translateY(50px)',
                opacity: animate ? 1 : 0,
               transition: `transform ${1+4}s ease, opacity ${1+4}s ease`
              ,display:"flex",justifyContent:"center"}}>
  <AppMenuCardBlueBG activeCard={""} icon={7} title ="Next Phase " onClickPopup={
                ()=>{ history.push(`${baseUrl}/labels`) 
                }}  />
  </div>
  </div></div>
    </div>  <div  className="CreateCourseStepsOuterRight " >
   
      <h1 style={{"textAlign":"center",
        transform: animate ? 'translateY(0)' : 'translateY(-50px)',
        opacity: animate ? 1 : 0,
        transition: 'transform 1s ease, opacity 1s ease',
      }}> Not Sure???  Just Mention <span className="coloredTextV1" > Approx Contents. </span> </h1>
      <div className="WhatsIncludedAddMoreCard" style={{
        transform: animate ? 'translateY(0)' : 'translateY(50px)',
        opacity: animate ? 1 : 0,
        transition: 'transform 2s ease, opacity 1s ease',
      }}>
      {flattenedData?flattenedData.map((item, index) => 
        (<><WhatsIncludedAddMore index={index} key={item.id} changeItemStatus ={updateItemStatus } 
          contentType={item.contentType} no={item.no} id={item.id} totalNumber={item.totalNumber} status={item.status} 
          contentIcon={item.contentIcon}  editable={item.editable}  changetotalNumber={updateItemTotalNumber} changeItemTitle={updateItemTitle } onRemove={removeItem} /></>)):'' }
    <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  onClick={()=>setItemArr([...itemArr, {no: itemArr.length, id: generateTimestamp()+8
      , totalNumber: 0,status:true,contentIcon:`BadgePlus`,
      contentType:"" ,editable:true}])} style={{width:"40px",height:"40px",cursor:"pointer",borderRadius:"50%",margin:"10px",
      background:"#958FDA"}} ><Plus  style={{margin:"9px"}}  color="#ffffff" size={22}/></div>


      <div style={{height:"130px",}}></div>
    </div>
 
   <div className="CreateCourseStepsOuterBottom" style={{padding:'15px',fontSize:'12px',marginBottom:'10px'}}>
    <div  >   </div>
  
    
    <button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{handleBack()}}  className="CreateCourseStepsOuterRightButtonBack"  type="submit"
     id="signupBtn"> Back </button>

 <button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{handleCreateProduct()}} style={{width:"140px",height:"55px"}} className="CreateCourseStepsOuterRightButton"  type="submit"
     id="signupBtn"> {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":productID?"Update":"Save"} </button>
     
  </div>
  
    <div  className="ikcraft_login-input-card">
   
      
  </div>

  <div> 
    
    
    
    
  </div>
 </div>
    
 <div></div>
 {goNextPopUp?<NextStepCardPopUp loadingText="Going Next..."  title="Next Step> Add  Thumbnails .   Let's Go Next" type="addAproxContent"
 closePopUp={()=>{setGoNextPopUp(false)}}
 onClickPopup={(type)=>{setTimeout(()=>{
  history.push(`${baseUrl}/thumbnails`)
 },1000)
  }}/>:""}

  </div></div>
</>}
    </>

}

export default ApproxContents;



